/**
 *@example getCleanObject({ thing: 'asd', other: undefined, emptyArray: [] }) // { thing: 'asd', emptyArray: null }
 */

export function cleanObject<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj).replaceAll(/\[\]/g, 'null'))
}
